module.exports = "/assets/data/39d74094ab6874964042fe0d36d5e390-L2.data.json";